export default {
  states: [
    {
      id: '',
      name: 'None',
      className: '',
      icon: 'hide',
      isActive: true
    },
    {
      id: 'isSelected',
      name: 'selected',
      className: 'isSelected',
      icon: 'hide'
    }
  ],
  defaultstates: ['selected']
};
